import { createSelector } from 'reselect'
import { IState } from 'types/States'

const selectLanguageRoot = (state: IState) => state.language

export const selectLanguageCode = createSelector(
  selectLanguageRoot,
  storeFolderState => storeFolderState,
)
